module.exports = __webpack_public_path__ + "img/homePageHeader.69b54df1.png";